:host {
  display: block;
}

.swatch {
  height: 50px;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin: 5px;
}

.swatch-section {
  display: inline-block;
  width: 100px;
}

.swatch div {
  background-color: #000;
  color: #fff;
  position: absolute;
  bottom: 0;
  padding: 0.1em;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 8pt;
  width: 100%;
  margin: 0;
}
